import * as bootstrap from "bootstrap/dist/js/bootstrap.bundle.min.js";
window.bootstrap = bootstrap;

import Swiper from "swiper/bundle";
import "swiper/css/bundle";

import Choices from "choices.js";

import "choices.js/public/assets/styles/choices.min.css";

import {Fancybox} from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

// equal height column
function equalizeColumns() {
    if (window.innerWidth >= 992) {
        let currentElement = document.querySelector(".dynamic-column");
        let nextElement = currentElement ? currentElement.nextElementSibling : null;

        if (currentElement && nextElement) {
            nextElement.style.height = currentElement.offsetHeight + "px";
            nextElement.style.width = window.innerWidth - currentElement.offsetWidth + "px";
        }
    }
}

equalizeColumns();

window.addEventListener("resize", equalizeColumns);

// light and dark mode logo animation gif
document.addEventListener("DOMContentLoaded", function () {
    if (window.innerWidth > 992) {
        var gifLogo = document.getElementById("gifImage");
        var gifLogoDark = document.getElementById("gifImageDark");
        var staticLogo = document.getElementById("staticImage");
        var staticLogoDark = document.getElementById("staticImageDark");

        if (staticLogo && staticLogoDark) {
            staticLogo.classList.add("hidden");
            staticLogoDark.classList.add("hidden");
        }

        setTimeout(function () {
            if (gifLogo) gifLogo.classList.add("hidden");
            if (gifLogoDark) gifLogoDark.classList.add("hidden");
            if (staticLogo) staticLogo.classList.add("show");
            if (staticLogoDark) staticLogoDark.classList.add("show");
        }, 3500);
    }
});

// audio and swiper
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".o-series-slider").forEach(function (container) {
        var swiperElement = container.querySelector(".swiper");
        var nextButton = container.querySelector(".swiper-button-next");
        var prevButton = container.querySelector(".swiper-button-prev");

        if (swiperElement && nextButton && prevButton) {
            var swiper = new Swiper(swiperElement, {
                slidesPerView: 4,
                spaceBetween: 30,
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1,
                    },
                    768: {
                        slidesPerView: 2,
                    },
                    992: {
                        slidesPerView: 3,
                    },
                    1200: {
                        slidesPerView: 4,
                    },
                },
            });
        }
    });

    const audioIcons = document.querySelectorAll(".icon-audio");

    if (audioIcons.length > 0) {
        audioIcons.forEach((audioIcon) => {
            let audioSrc = audioIcon.getAttribute("data-audio");
            let audio = new Audio(audioSrc);
            let isPlaying = false;

            audioIcon.addEventListener("click", function () {
                if (!isPlaying) {
                    audio.play();
                    audioIcon.classList.add("active");
                    isPlaying = true;
                } else {
                    audio.pause();
                    audioIcon.classList.remove("active");
                    isPlaying = false;
                }

                audio.addEventListener("ended", function () {
                    audioIcon.classList.remove("active");
                    isPlaying = false;
                });
            });
        });
    }
});

var searchElement = document.getElementById("search-js-choice");
if (searchElement) {
    var search = new Choices(searchElement, {
        allowHTML: true,
        delimiter: ",",
        editItems: true,
        placeholderValue: myTranslations.click_to_search ? myTranslations.click_to_search : "Click to search",
        removeItemButton: true,
    });
}

setTimeout(function () {
    var parentDiv = document.querySelector(".language-dropdown-container");
    if (parentDiv) {
        parentDiv.classList.add("show");
        var languageElement = parentDiv.querySelector('[name="language-js-choice"]');
        if (languageElement) {
            var language = new Choices(languageElement, {
                allowHTML: true,
                delimiter: ",",
                editItems: true,
                removeItemButton: false,
                searchEnabled: false,
            });
        }
    }
}, 1000);

// Filters on Video and Audio layout - changing from tags on desktop to select dropdown on mobile
window.addEventListener("resize", function () {
    var languageContainers = document.querySelectorAll(".o-video-layout__headline-and-filter");
    languageContainers.forEach(function (container) {
        if (window.innerWidth <= 991) {
            showLanguageSelect(container);
        } else {
            showLanguageTags(container);
        }
    });
});

function showLanguageSelect(container) {
    var languageTagsContainer = container.querySelector(".m-tags__tags-wrapper");
    if (!languageTagsContainer) {
        return; // Exit the function if container doesn't exist
    }

    languageTagsContainer.style.display = "none";

    var languageSelectContainer = container.querySelector(".m-tags__select-wrapper");
    if (languageSelectContainer) {
        var existingSelect = languageSelectContainer.querySelector("select");
        if (!existingSelect) {
            var select = document.createElement("select");
            select.className = "m-tags__child";

            var languageButtons = container.querySelectorAll(".m-tags__tags-wrapper .m-tags__child");
            languageButtons.forEach(function (button) {
                var option = document.createElement("option");
                option.value = button.textContent.toLowerCase();
                option.text = button.textContent;
                select.appendChild(option);
            });
            languageSelectContainer.appendChild(select);
        }
    }
}

function showLanguageTags(container) {
    var languageTagsContainer = container.querySelector(".m-tags__tags-wrapper");
    if (languageTagsContainer) {
        languageTagsContainer.style.display = "flex";
    }

    var languageSelectContainer = container.querySelector(".m-tags__select-wrapper");
    if (languageSelectContainer) {
        languageSelectContainer.innerHTML = ""; // Clear dropdown select
    }
}

// Initial check on page load
var languageContainers = document.querySelectorAll(".o-video-layout__headline-and-filter");
languageContainers.forEach(function (container) {
    if (window.innerWidth <= 991) {
        showLanguageSelect(container);
    } else {
        showLanguageTags(container);
    }
});



// SCRIPTS FROM FOOTER
document.querySelectorAll("[data-navigation]").forEach((el) => {
    if (window.location.href.includes("/category/" + el.dataset.navigation)) {
        el.classList.add("is-active");
    }
});

// Add class is-active for Video / Audio filters
document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".m-tags__child").forEach((el) => {
        const urlParts = window.location.href.split("/");
        const categoryIndex = urlParts.indexOf("category");

        if (categoryIndex !== -1) {
            if (urlParts[categoryIndex + 2] === el.dataset.category) {
                el.classList.add("is-active");
            }
        }
    });
});

document.addEventListener("DOMContentLoaded", function () {
    function set_dark_mode_cookie() {
        document.cookie = "yonkovNightMode=1; path=/";
    }

    function remove_dark_mode_cookie() {
        document.cookie =
            "yonkovNightMode=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    }

    function toggle_dark_mode() {
        const html = document.documentElement;
        const currentTheme = html.getAttribute("data-bs-theme");
        const darkModeImages = document.querySelectorAll(".darkModeImage");
        const lightModeImages = document.querySelectorAll(".lightModeImage");
        const newTheme = currentTheme === "dark" ? "light" : "dark";
        html.setAttribute("data-bs-theme", newTheme);

        if (newTheme === "dark") {
            set_dark_mode_cookie();
            darkModeImages.forEach(function (element) {
                element.classList.remove("d-none");
                element.classList.add("d-flex");
            });
            lightModeImages.forEach(function (element) {
                element.classList.remove("d-flex");
                element.classList.add("d-none");
            });
        } else {
            remove_dark_mode_cookie();
            lightModeImages.forEach(function (element) {
                element.classList.remove("d-none");
                element.classList.add("d-flex");
            });
            darkModeImages.forEach(function (element) {
                element.classList.remove("d-flex");
                element.classList.add("d-none");
            });
        }

        // Update all text-switch elements
        document
            .querySelectorAll(".text-switch")
            .forEach(function (textSwitchSpan) {
                if (newTheme === "dark") {
                    textSwitchSpan.textContent = myTranslations.switch_to_light_mode ? myTranslations.switch_to_light_mode : "Switch to light mode";
                } else {
                    textSwitchSpan.textContent = myTranslations.switch_to_dark_mode ? myTranslations.switch_to_dark_mode : "Switch to dark mode";
                }
            });
    }

    function update_dark_mode() {
        var yonkov_night_mode = document.cookie.replace(
            /(?:(?:^|.*;\s*)yonkovNightMode\s*\=\s*([^;]*).*$)|^.*$/,
            "$1"
        );
        if (yonkov_night_mode === "1") {
            document.querySelectorAll(".dark-theme-js").forEach(function (btn) {
                btn.classList.add("active");
            });
            document
                .querySelectorAll(".text-switch")
                .forEach(function (textSwitchSpan) {
                    textSwitchSpan.textContent = myTranslations.switch_to_light_mode ? myTranslations.switch_to_light_mode : "Switch to light mode";
                });
            document.documentElement.setAttribute("data-bs-theme", "dark");
            toggleImageVisibility(true);
        } else {
            document.querySelectorAll(".dark-theme-js").forEach(function (btn) {
                btn.classList.remove("active");
            });
            document
                .querySelectorAll(".text-switch")
                .forEach(function (textSwitchSpan) {
                    textSwitchSpan.textContent = myTranslations.switch_to_dark_mode ? myTranslations.switch_to_dark_mode : "Switch to dark mode";
                });
            document.documentElement.removeAttribute("data-bs-theme");
            toggleImageVisibility(false);
        }
    }

    function toggleImageVisibility(darkMode) {
        var darkModeImages = document.querySelectorAll(".darkModeImage");
        var lightModeImages = document.querySelectorAll(".lightModeImage");

        if (darkMode) {
            darkModeImages.forEach(function (element) {
                element.classList.remove("d-none");
                element.classList.add("d-flex");
            });
            lightModeImages.forEach(function (element) {
                element.classList.remove("d-flex");
                element.classList.add("d-none");
            });
        } else {
            lightModeImages.forEach(function (element) {
                element.classList.remove("d-none");
                element.classList.add("d-flex");
            });
            darkModeImages.forEach(function (element) {
                element.classList.remove("d-flex");
                element.classList.add("d-none");
            });
        }
    }

    document.querySelectorAll(".dark-theme-js").forEach(function (btn) {
        btn.addEventListener("click", function () {
            toggle_dark_mode();
        });
    });

    update_dark_mode();

    document.querySelectorAll('[name="language-js-choice"]').forEach((el) => {
        el.addEventListener("change", function (e) {
            window.location.href = el.value;
        });
    });
});



var swiperImages = new Swiper(".swiper-images", {
    loop: true,
    slidesPerView: 1,

    navigation: {
        nextEl: ".next-images",
        prevEl: ".prev-images",
    },
});



// Slider with Popup
document.addEventListener("DOMContentLoaded", function () {
    const galleries = document.querySelectorAll(".gallery-container"); // Select each gallery container

    galleries.forEach((gallery, galleryIndex) => {
        const bigSlider = gallery.querySelector("#big-slider ul"); // Select the big-slider within the gallery
        const thumbSlider = gallery.querySelector("#thumb-slider ul"); // Select the thumb-slider within the gallery
        const thumbSlides = gallery.querySelectorAll("#thumb-slider li");
        const slideCount = thumbSlides.length;
        const visibleThumbs = 4;
        let currentIndex = 0;

        if (bigSlider && thumbSlider && thumbSlides.length > 0) {
            const bigSliderLinks = gallery.querySelectorAll("#big-slider a.swipebox");

            bigSliderLinks.forEach((link, index) => {
                const img = link.querySelector('img');
                if (img) {
                    // Set the href attribute to the src of the image for each link
                    link.setAttribute("href", img.getAttribute("src"));
                }

                // Check if Fancybox is already bound by checking a custom data attribute
                if (!link.hasAttribute("data-fancybox-initialized")) {
                    // Group each gallery separately using a unique data-fancybox value
                    link.setAttribute("data-fancybox", `fancybox-slider-${galleryIndex}`);

                    // Get the photographer info from "productBlock__fotographer"
                    const photographerElement = link.closest('.productBlock').querySelector('.productBlock__fotographer');
                    const photographer = photographerElement ? photographerElement.textContent.trim() : "";

                    // Get the title
                    const title = link.getAttribute("title") || "";

                    // Build the caption based on whether title and photographer exist
                    let caption = "";

                    if (title) {
                        caption += `<div class="fancybox-title">${title}</div>`;
                    }

                    if (photographer) {
                        caption += `<div class="fancybox-description">${photographer}</div>`;
                    }

                    // Set data-caption only if there's content
                    if (caption) {
                        link.setAttribute("data-caption", caption);
                    }

                    // Mark the link as initialized for Fancybox
                    link.setAttribute("data-fancybox-initialized", "true");
                }
            });

            function updateSlider() {
                bigSlider.style.transform = `translateX(-${currentIndex * 100}%)`;

                thumbSlides.forEach((thumb, index) => {
                    thumb.classList.toggle("active", index === currentIndex);
                });

                const thumbWidth = thumbSlides[0].offsetWidth;
                const maxOffset = Math.max(
                    0,
                    thumbSlider.scrollWidth - thumbSlider.offsetWidth
                );
                const offset = Math.min(
                    (currentIndex - Math.floor(visibleThumbs / 2)) * thumbWidth,
                    maxOffset
                );

                thumbSlider.style.transform = `translateX(-${offset}px)`;

                const nextButton = gallery.querySelector(".next-button");
                if (nextButton) {
                    nextButton.disabled = currentIndex >= slideCount - 1;
                }

                const prevButton = gallery.querySelector(".prev-button");
                if (prevButton) {
                    prevButton.disabled = currentIndex <= 0;
                }
            }

            function showNextSlide() {
                if (currentIndex < slideCount - 1) {
                    currentIndex++;
                    updateSlider();
                }
            }

            function showPreviousSlide() {
                if (currentIndex > 0) {
                    currentIndex--;
                    updateSlider();
                }
            }

            // Thumbnail click
            thumbSlides.forEach((thumb, index) => {
                thumb.addEventListener("click", function (event) {
                    event.preventDefault();
                    currentIndex = index;
                    updateSlider();
                });
            });

            // Navigation buttons
            const nextButton = gallery.querySelector(".next-button");
            const prevButton = gallery.querySelector(".prev-button");

            if (nextButton) {
                nextButton.addEventListener("click", showNextSlide);
            }

            if (prevButton) {
                prevButton.addEventListener("click", showPreviousSlide);
            }

            updateSlider();

            // Initialize Fancybox for the gallery links, only if it's not already initialized
            if (typeof Fancybox !== 'undefined' && !Fancybox.getInstance()) {
                Fancybox.bind(`[data-fancybox="fancybox-slider-${galleryIndex}"]`, {
                    captions: function (fancybox, slide) {
                        return slide.$trigger.getAttribute("data-caption") || "";
                    },
                    infinite: false, // Prevents looping through galleries
                });
            } else if (typeof Fancybox === 'undefined') {
                console.error("Fancybox is not loaded.");
            }
        }
    });
});



//  FOOTER LINKS
document.addEventListener('DOMContentLoaded', function () {
    const menuLinks = document.querySelectorAll('.o-footer__mobile-links');

    function toggleAccordion(event) {
        event.preventDefault();

        const parent = this.closest('div');  // Find the closest div container

        if (parent) {
            const isOpen = parent.classList.contains('is-open');
            parent.classList.toggle('is-open', !isOpen);

            // Close all other sections
            menuLinks.forEach(function (otherLink) {
                const otherParent = otherLink.closest('div');
                if (otherParent && otherParent !== parent) {
                    otherParent.classList.remove('is-open');
                }
            });
        }
    }

    // Fix for iPhone - Ensure touch events do not conflict with clicks
    function handleTouch(event) {
        event.preventDefault();
        this.click();
    }

    // Apply accordion functionality on screens smaller than 992px
    function handleResize() {
        if (window.innerWidth < 992) {
            // Remove existing event listeners first (optional but useful if resizing)
            menuLinks.forEach(function (menuLink) {
                menuLink.removeEventListener('click', toggleAccordion);
                menuLink.removeEventListener('touchstart', handleTouch);
            });

            // Add event listeners for click and touchstart
            menuLinks.forEach(function (menuLink) {
                menuLink.addEventListener('click', toggleAccordion);
                menuLink.addEventListener('touchstart', handleTouch);  // Handle iPhone touch issue
            });
        } else {
            // Remove 'is-open' class and event listeners on larger screens
            menuLinks.forEach(function (menuLink) {
                const parent = menuLink.closest('div');
                if (parent) {
                    parent.classList.remove('is-open');
                }
                menuLink.removeEventListener('click', toggleAccordion);
                menuLink.removeEventListener('touchstart', handleTouch);
            });
        }
    }

    // Initial setup and handling resize event
    handleResize();
    window.addEventListener('resize', handleResize);
});



// Video Popup
document.addEventListener("DOMContentLoaded", function() {
    function attachYouTubeModalListeners() {
        const youtubeArticles = document.querySelectorAll(".m-youtube-article, .m-row-video-article, .m-column-video-article, .m-popular-video");

        youtubeArticles.forEach(article => {
            if (article.classList.contains("audio")) {
                return;
            }

            article.addEventListener("click", function(event) {
                const tagsSection = article.querySelector(".m-category-article__content__bottom__tags");
                const gSpeech = article.querySelector(".gsp_circle_player");

                if ((tagsSection && tagsSection.contains(event.target)) || (gSpeech && gSpeech.contains(event.target))) {
                    return;
                }

                const iframe = article.querySelector("iframe");
                if (!iframe) return;

                const videoSrc = iframe.src.replace("embed/", "embed/").concat("?autoplay=1&showinfo=0");
                showVideoModal(videoSrc);
            });
        });
    }

    function showVideoModal(videoSrc) {
        if (document.getElementById("videoModal")) return;

        // Create a modal element
        const modalHTML = `
                    <div class="modal videoModal fade" id="videoModal" tabindex="-1" aria-labelledby="videoModalLabel" aria-hidden="true">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>
                                <div class="modal-body">
                                    <iframe width="100%" height="100%" src="${videoSrc}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                `;

        document.body.insertAdjacentHTML("beforeend", modalHTML);

        const modalElement = document.getElementById("videoModal");
        const modal = new bootstrap.Modal(modalElement);
        modal.show();

        modalElement.addEventListener("hidden.bs.modal", function() {
            modalElement.remove();
        });
    }

    function checkQueryParams() {
        const urlParams = new URLSearchParams(window.location.search);
        const videoId = urlParams.get('videoId');
        if (videoId) {
            fetch(`/wp-admin/admin-ajax.php?action=get_video_details&videoId=${videoId}`)
                .then(response => response.json())
                .then(data => {
                    if (data.success && data.data.link) {
                        const doc = new DOMParser().parseFromString(data.data.link, 'text/html');
                        const iframe = doc.querySelector('iframe');
                        if (iframe) {
                            const videoSrc = iframe.src.replace('embed/', 'embed/').concat('?autoplay=1&showinfo=0');
                            showVideoModal(videoSrc);
                        } else {
                            console.error("Iframe not found in the provided HTML string.");
                        }
                    } else {
                        console.error(data.data);
                    }
                })
                .catch(error => console.error('Error fetching video details:', error));
        }
    }

    attachYouTubeModalListeners();
    checkQueryParams();

    document.addEventListener('ajaxContentLoaded', function() {
        attachYouTubeModalListeners();
    });
});


// Gallery Popup
document.addEventListener("DOMContentLoaded", function () {
    // Select all gallery blocks
    const galleries = document.querySelectorAll(".wp-block-gallery");

    galleries.forEach((gallery, index) => {
        // Select all figure elements in the current gallery block
        const galleryFigures = gallery.querySelectorAll("figure");

        galleryFigures.forEach((figure) => {
            const img = figure.querySelector("img");
            const figcaption = figure.querySelector("figcaption"); // Get the figcaption
            const captionText = figcaption ? figcaption.innerText : ''; // Get the text from figcaption if it exists

            // Check if img exists and has a valid src
            if (img && img.src) {
                // Check if the image is already wrapped in a link
                if (!img.parentElement.matches('a')) {
                    // Create a wrapper link element
                    const link = document.createElement("a");
                    link.href = img.src; // Link to the full-size image
                    link.setAttribute("data-fancybox", `fancybox-gallery-${index}`); // Assign a unique group name

                    // Set the caption for Fancybox
                    if (captionText) {
                        link.setAttribute("data-caption", captionText);
                    }

                    // Wrap the image with the link element
                    img.parentNode.insertBefore(link, img);
                    link.appendChild(img);
                }
            }
        });

        // Initialize Fancybox for the current gallery images
        if (typeof Fancybox !== 'undefined' && !Fancybox.getInstance()) {
            Fancybox.bind(`[data-fancybox="fancybox-gallery-${index}"]`, {
                mainClass: 'fancybox-gallery-images',
            });
        } else if (typeof Fancybox === 'undefined') {
            console.error("Fancybox is not loaded.");
        }
    });
});


// Import Vanilla LazyLoad
import LazyLoad from "vanilla-lazyload";

document.addEventListener("DOMContentLoaded", function () {
    // Placeholder image (light gray with "Loading..." text)
    const placeholder =
        "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23f0f0f0'/%3E%3Ctext x='50%' y='50%' fill='%23d0d0d0' font-size='20' dy='.3em' text-anchor='middle'%3ELoading...%3C/text%3E%3C/svg%3E";

    // Select all elements that should be lazy-loaded
    const lazyElements = document.querySelectorAll("figure[data-src], img[data-src], iframe[data-src], figure[src], img[src], iframe[src], figure[style*='background-image']");

    lazyElements.forEach((element) => {
        // Add "lazy" class to every lazy-loadable element
        element.classList.add("lazy");

        // For <img> and <iframe> elements
        if (element.tagName.toLowerCase() === "img" || element.tagName.toLowerCase() === "iframe") {
            if (element.hasAttribute("src")) {
                // Move current src to data-src and set the placeholder as the src
                element.setAttribute("data-src", element.getAttribute("src"));
                element.setAttribute("src", placeholder); // Set placeholder image
            }

            // Handle <source> elements inside <picture>
            if (element.parentElement.tagName.toLowerCase() === "picture") {
                const sources = element.parentElement.querySelectorAll("source");
                sources.forEach((source) => {
                    if (source.hasAttribute("srcset")) {
                        source.setAttribute("data-srcset", source.getAttribute("srcset"));
                        source.removeAttribute("srcset");
                    }
                });
            }
        }

        // For elements with background images
        if (element.style.backgroundImage && element.style.backgroundImage.includes("url(")) {
            const match = /url\(["']?(.*?)["']?\)/.exec(element.style.backgroundImage);

            if (match && match[1]) {
                // Step 1: Store current background URL in data-bg
                element.setAttribute("data-bg", match[1]);

                // Step 2: Use requestAnimationFrame to ensure placeholder is applied immediately
                requestAnimationFrame(() => {
                    element.style.backgroundImage = `url('${placeholder}')`; // Set placeholder as background
                });
            }
        }
    });

    // Initialize Vanilla LazyLoad with specified options
    new LazyLoad({
        elements_selector: ".lazy",
        threshold: 300, // Lazy load when element is within 300px from viewport
        callback_loaded: (element) => {
            // Add fade-in effect when the element has fully loaded
            element.classList.add("lazy-loaded");

            // Remove lazy-loading attributes after loading
            if (element.hasAttribute("data-src")) {
                element.removeAttribute("data-src");
            }
            if (element.hasAttribute("data-bg")) {
                element.removeAttribute("data-bg");
            }
        },
        callback_error: (element) => {
            // Handle any loading errors (optional)
            element.classList.add("lazy-error");
        },
    });
});

// Load more
document.addEventListener('DOMContentLoaded', function () {
    var loadMoreButton = document.getElementById('more_posts');
    if (loadMoreButton) {
        var page = 1;
        var postsPerPage = 5;
        var postsNotIn = [];
        var loading = false;
        var container = document.getElementById('ajax-posts');
        var maxNumPages = parseInt(container.getAttribute('data-pages'), 10);

        if (loadMoreButton.dataset.type === 'video') {
            maxNumPages = maxNumPages / 4;
        }

        loadMoreButton.addEventListener('click', function () {

            loadMoreButton.textContent = myTranslations.loading ? myTranslations.loading + ' ...' : 'Loading ...';
            loadMoreButton.disabled = true;

            if (!loading) {
                loading = true;
                var data = new URLSearchParams();
                data.append('action', 'custom_load_more_posts');
                data.append('type', loadMoreButton.dataset.type);
                data.append('postsPerPage', loadMoreButton.dataset.postsPerPage);
                data.append('postsNotIn', loadMoreButton.dataset.postsNotIn);
                data.append('page', page);
                data.append('nonce', window.nonce);  // Add nonce to the data

                fetch(window.wp_ajax, { // Use the global variable for AJAX URL
                    method: 'POST',
                    body: data,
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                })
                    .then(response => response.text())
                    .then(function (response) {
                        if (response) {
                            container.insertAdjacentHTML('beforeend', response);
                            loading = false;
                            loadMoreButton.textContent = myTranslations.show_more ? myTranslations.show_more : 'Show more';
                            loadMoreButton.disabled = false;

                            const event = new Event('ajaxContentLoaded');
                            document.dispatchEvent(event);

                            if (page === maxNumPages) {
                                loadMoreButton.style.display = 'none';
                            } else {
                                if (loadMoreButton.dataset.type !== 'video')
                                    loadMoreButton.insertAdjacentElement('afterend', container);
                            }
                            loadMoreButton.disabled = false;
                        } else {
                            loadMoreButton.style.display = 'none';
                        }
                    })
                    .catch(function (error) {
                        loading = false;
                        loadMoreButton.disabled = false;
                    });
            }

            page++;

        });
    }
});

document.addEventListener('DOMContentLoaded', function () {
    const newsletterElement = document.getElementById('newsletterModal');
    if (newsletterElement) {
        const newsletterModal = new bootstrap.Modal(newsletterElement);
        newsletterModal.show();
    }
});


// News slider
document.addEventListener("DOMContentLoaded", function () {
    var paginationContainer = document.querySelector(".swiper-news-pagination");
    var swiperContainer = document.querySelector(".swiper-news");
    if (!swiperContainer) { return; }

    var swiperNews = new Swiper(swiperContainer, {
        slidesPerView: 5,
        allowTouchMove: false,
        simulateTouch: false,
        speed: 1000,
        grid: { rows: 1 },
        breakpoints: {
            0: { slidesPerView: 1, grid: { rows: 2 } },
            576: { slidesPerView: 2, grid: { rows: 1 } },
            768: { slidesPerView: 3 },
            992: { slidesPerView: 4 },
            1400: { slidesPerView: 5 }
        },
        pagination: {
            el: ".swiper-news-pagination",
            clickable: true,
            type: "custom",
            renderCustom: function (swiper, current, total) {
                let slidesPerView = getSlidesPerView();
                let totalPages = Math.ceil(total / slidesPerView);
                let currentPage = Math.ceil((current + 1) / slidesPerView);

                let paginationHtml = "";

                // Previous Button
                paginationHtml += `<span class="prev page-numbers" data-action="prev">&lt;</span> `;

                // First Page
                paginationHtml += `<span class="page-numbers ${currentPage === 1 ? 'current' : ''}" data-page="1">1</span> `;

                // Middle Pages
                if (currentPage > 3) {
                    paginationHtml += `<span class="page-numbers dots">...</span> `;
                }

                let start = Math.max(2, currentPage - 1);
                let end = Math.min(totalPages - 1, currentPage + 1);

                for (let i = start; i <= end; i++) {
                    paginationHtml += `<span class="page-numbers ${i === currentPage ? 'current' : ''}" data-page="${i}">${i}</span> `;
                }

                if (currentPage < totalPages - 2) {
                    paginationHtml += `<span class="page-numbers dots">...</span> `;
                }

                // Last Page
                paginationHtml += `<span class="page-numbers ${currentPage === totalPages ? 'current' : ''}" data-page="${totalPages}">${totalPages}</span> `;

                // Next Button
                paginationHtml += `<span class="next page-numbers" data-action="next">&gt;</span>`;

                return paginationHtml;
            },
        },
    });

    function getSlidesPerView() {
        return swiperNews && swiperNews.params ? swiperNews.params.slidesPerView || 1 : 1;
    }

    function slideNextGroup() {
        let slidesPerView = getSlidesPerView();
        let newIndex = swiperNews.activeIndex + slidesPerView;
        swiperNews.slideTo(newIndex);
    }

    function slidePrevGroup() {
        let slidesPerView = getSlidesPerView();
        let newIndex = swiperNews.activeIndex - slidesPerView;
        swiperNews.slideTo(newIndex);
    }

    // Ensure pagination updates correctly on initialization
    swiperNews.on('init', function () {
        swiperNews.pagination.render();
        swiperNews.pagination.update();
    });
    swiperNews.init();

    // Handle Pagination & Navigation Clicks
    paginationContainer.addEventListener("click", function (e) {
        if (e.target.classList.contains("page-numbers")) {
            e.preventDefault();

            if (e.target.dataset.action === "next") {
                slideNextGroup();
            } else if (e.target.dataset.action === "prev") {
                slidePrevGroup();
            } else {
                let pageIndex = parseInt(e.target.dataset.page, 10) - 1;
                let slidesPerView = getSlidesPerView();
                swiperNews.slideTo(pageIndex * slidesPerView);
            }
        }
    });

    // Force a pagination update after a slight delay
    setTimeout(() => {
        swiperNews.pagination.render();
        swiperNews.pagination.update();
    }, 50);
});



// SNAPSHOT SLIDER
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".swiper-snapshot").forEach((swiperEl, i) => {
        const groupName = `snapshot-${i}`;

        swiperEl.querySelectorAll(".swiper-slide a").forEach((el) => {
            el.setAttribute("data-fancybox", groupName);
        });

        const snapshotSwiper = new Swiper(swiperEl, {
            pagination: {
                el: swiperEl.querySelector(".swiper-snapshot-pagination"),
                clickable: true,
            },
            slidesPerView: 1,
        });

        Fancybox.bind(`[data-fancybox="${groupName}"]`, {
            Carousel: {
                transition: "slide",
                Dots: true,
            },
            Images: {
                zoom: false
            },
            dragToClose: false,
            animated: false,
            autoFocus: false,
            closeButton: true,
            keyboard: {
                Escape: "close",
                ArrowLeft: "prev",
                ArrowRight: "next",
            },
            on: {
                ready: (fancybox) => {
                    const container = document.querySelector(".fancybox__container");
                    container.classList.add("fancybox-snapshot");

                    let startY = 0;
                    const threshold = 50;

                    const onTouchStart = (event) => {
                        startY = event.touches[0].clientY;
                    };

                    const onTouchMove = (event) => {
                        let deltaY = event.touches[0].clientY - startY;
                        if (Math.abs(deltaY) > threshold) {
                            Fancybox.close();
                        }
                    };

                    container.addEventListener("touchstart", onTouchStart);
                    container.addEventListener("touchmove", onTouchMove);

                    fancybox.container.__onTouchStart = onTouchStart;
                    fancybox.container.__onTouchMove = onTouchMove;
                },
                destroy: (fancybox) => {
                    const container = document.querySelector(".fancybox__container");
                    if (container) {
                        container.classList.remove("fancybox-snapshot");
                        container.removeEventListener("touchstart", fancybox.container.__onTouchStart);
                        container.removeEventListener("touchmove", fancybox.container.__onTouchMove);
                    }
                }
            }
        });
    });
});